import { ContactForm } from "./(sections)/ContactForm";
import { ContactInfo } from "./(sections)/ContactInfo";

export function ContactPage() {
    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-7xl mx-auto px-6">
                <div className="mb-16">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">Get in touch</p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">Contact</h1>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
                    <div className="lg:col-span-2">
                        <ContactForm />
                    </div>
                    <ContactInfo />
                </div>
            </div>
        </div>
    );
}
